export default __webpack_public_path__ + "static/media/people6.9c22481a.png";